import { NotificationService, LoaderService, CONSTANT, EVENTO, TOOLTIPS, ICONS, ACTIONS } from "../../../../shared/session/index";
import { CustomValidators, RegularExpression, RegularExpressionMessage } from '../../../../shared/validation/customvalidation';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Access, Iaccess } from "../shared/access.model";
import { Aplicacion } from '../../Aplicaciones/shared/aplicacion.model'
import { AccessService } from "../shared/access.service";
import { AplicacionService } from "../../Aplicaciones/shared/aplicacion.service";
import { ModuleService } from "../../modules/shared/module.service";
import { Module } from "../../modules/shared/module.model";

@Component({
  //moduleId: module.id,
  selector: 'app-access-new',
  templateUrl: 'access-new.component.html'
})
export class AccessNewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any
  @Input() titlePage: string;

  formGroupNewAccess: FormGroup;
  msgSuccessInsert: string;
  msgErrorInsert: string;
  obligatorioMsg: string;
  access: Iaccess;
  maxLengthMsg: string;
  pathMaxLength: number;
  nomAccessMaxLength: number;
  descripcionMaxLength: number;
  nomAccessPatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;
  buttonGroup: any;
  nomPathMaxLength: number;
  msgErrorGetAplicaciones: string;

  // Combos
  aplicaciones: Aplicacion[];
  modules: Module[];

  constructor(
    private loaderService: LoaderService,
    private accessService: AccessService,
    private notificationService: NotificationService,
    private aplicacionService: AplicacionService,
    private moduleService: ModuleService,
    public fb: FormBuilder
  ) { }

  ngOnInit() {
    this.access = new Access(0, 1, "", "", "", "", "", true, "activo", "", "", "", "", "", 1);
    this.msgSuccessInsert = 'Se registró satisfactoriamente';
    this.msgErrorInsert = 'Error al registrar el Acceso';
    this.obligatorioMsg = 'Campo Obligatorio';
    this.maxLengthMsg = 'El tamaño máximo es de ';
    this.msgErrorGetAplicaciones = "Error al listar las aplicaciones";
    this.nomPathMaxLength = 100;
    this.nomAccessMaxLength = 100;
    this.descripcionMaxLength = 250;
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.setValuesFormBuilder();
    this.listarAplicacionCbo();
    // this.listarPorModuleCbo('',1);
  }
  private setValuesFormBuilder() {
    this.formGroupNewAccess = this.fb.group({
      accessName: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomAccessMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      path: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomPathMaxLength)
      ])],
      icono: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomPathMaxLength)
      ])],
      description: ['', Validators.compose([
        Validators.maxLength(this.descripcionMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      moduleID: [, Validators.compose([
        Validators.required,
      ])],
      aplicacionID: [1]
    });
  }

  changeEvent(access: Iaccess) {
    this.data = { access: { ID: access.ID, Name: access.Name } };
    this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
  }

  formGroupNewAccessSubmit(event) {
    if (this.formGroupNewAccess.invalid)
      return;
    this.access.Name = event.value.accessName;
    this.access.ModuleID = event.value.moduleID;
    this.access.Path = event.value.path;
    this.access.Icono = event.value.icono;
    this.access.Description = event.value.description;
    this.access.AplicacionID = event.value.aplicacionID;

    this.insertarAccess(this.access);
  }
  modulesByApplication(){
    this.listarPorModuleCbo('',Number(this.formGroupNewAccess.get('aplicacionID').value))
  }
  private insertarAccess(access: Iaccess) {
    this.loaderService.show();
    this.access.Status = CONSTANT.estadoRegistro.activo;
    this.accessService.insertarAccess(access)
      .subscribe(res => {
        access.ID = res;
        this.changeEvent(access);
        this.notificationService.successful("Se grabó satisfactoriamente");
      },
        error => {
          this.notificationService.error(this.msgErrorInsert);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  private listarAplicacionCbo(): void {
    this.loaderService.show();
    this.aplicacionService.listarApplication()
      .subscribe(res => {
        this.aplicaciones = res;
      },
        error => {
          this.notificationService.error(this.msgErrorGetAplicaciones);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }
  private listarPorModuleCbo(filtro: string, pAplicacionID: number): void {
    this.loaderService.show();
    this.moduleService.listarPorModulos(filtro, pAplicacionID, 0, 0)
      .subscribe(res => {
        this.modules = res;
      },
        error => {
          this.notificationService.error(this.msgErrorGetAplicaciones);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }
}
